<!-- Six dots, two by three: a handle to drag by -->
<svg viewBox="0 0 10 16" fill="currentColor" width="0.625em" height="1em">
  <circle cx="2.5" cy="3" r="1.5" />
  <circle cx="7.5" cy="3" r="1.5" />
  <circle cx="2.5" cy="8" r="1.5" />
  <circle cx="7.5" cy="8" r="1.5" />
  <circle cx="2.5" cy="13" r="1.5" />
  <circle cx="7.5" cy="13" r="1.5" />
</svg>
